export interface Plan {
  id: number;
  name: string;
  price: number;
  currency: string;
  description: string;
  benefits: string[];
  mercadopago_plan_id?: string; // Optional: Mercado Pago's preapproval_plan_id if managed separately
}

export interface FeatureConsumption {
  limit: number;
  usage: number;
  period_start: string; // ISO Date string
  period_end: string;   // ISO Date string
  is_unlimited: boolean;
  additional_packages_limit?: number;
  additional_packages_usage?: number;
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  TRIAL = 'trial',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}

export enum SubscriptionPaymentMethod {
  CASH = 'cash',
  CREDIT_CARD = 'credit_card',
}

export interface Subscription {
  id: number;
  userId: number; // Assuming a user ID is associated
  planId: number;
  mercadopago_preapproval_id?: string; // Mercado Pago's preapproval plan ID
  status: SubscriptionStatus;
  currentPeriodStart?: Date;
  currentPeriodEnd?: Date;
  createdAt: Date;
  updatedAt: Date;
  reason?: string; // Reason for cancellation, etc.
  invoiceEnable?: boolean;
  electronic_documents?: FeatureConsumption;
}

// Placeholder for empty array response from use cases
export const EmptyArray = [];
